export default __webpack_public_path__ + "static/blue_prism-59a95b451ab8f37956adde70bb836cb5.png";